/**
 * Güven ve risk saga — V2 Faz F.
 * Backend: Komut.Rentificial.Application/Controllers/Admin/Trust/TrustController.cs
 */
import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";

import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { SagaActionParams, SagaGenericParams } from "src/request/types";

import { Dispute, FraudFlag, ListingVerification, TrustOverview, TrustSupplier } from "./type";

export const getTrustOverview = createAction(
  "GET_TRUST_OVERVIEW",
  ({ payload }: SagaActionParams<TrustOverview>) => ({
    payload,
    url: "/api/admin/trust/overview",
  })
);

export const getTrustSuppliers = createAction(
  "GET_TRUST_SUPPLIERS",
  ({ payload, params }: SagaActionParams<TrustSupplier[]>) => ({
    payload,
    url: "/api/admin/trust/suppliers" + (params ?? ""),
  })
);

/** Güven kademesi arama sıralamasını etkiler. */
export const setTrustTier = createAction(
  "SET_TRUST_TIER",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/trust/suppliers/" + id + "/tier",
  })
);

/** Kalite kapısı kapanırsa tedarikçinin TÜM ürünleri aramadan düşer. */
export const setQualityFloor = createAction(
  "SET_QUALITY_FLOOR",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/trust/suppliers/" + id + "/quality-floor",
  })
);

export const getFraudFlags = createAction(
  "GET_FRAUD_FLAGS",
  ({ payload, params }: SagaActionParams<FraudFlag[]>) => ({
    payload,
    url: "/api/admin/trust/flags" + (params ?? ""),
  })
);

export const resolveFraudFlag = createAction(
  "RESOLVE_FRAUD_FLAG",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/trust/flags/" + id + "/resolve",
  })
);

export const getDisputes = createAction(
  "GET_DISPUTES",
  ({ payload, params }: SagaActionParams<Dispute[]>) => ({
    payload,
    url: "/api/admin/trust/disputes" + (params ?? ""),
  })
);

export const setDisputeStatus = createAction(
  "SET_DISPUTE_STATUS",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/trust/disputes/" + id + "/status",
  })
);

export const getVerifications = createAction(
  "GET_LISTING_VERIFICATIONS",
  ({ payload, params }: SagaActionParams<ListingVerification[]>) => ({
    payload,
    url: "/api/admin/trust/verifications" + (params ?? ""),
  })
);

export const decideVerification = createAction(
  "DECIDE_LISTING_VERIFICATION",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/trust/verifications/" + id + "/decide",
  })
);

const trustSaga = [
  takeLatest<any>(getTrustOverview.toString(), (p: SagaGenericParams<TrustOverview>) => getSaga<TrustOverview>(p)),
  takeLatest<any>(getTrustSuppliers.toString(), (p: SagaGenericParams<TrustSupplier[]>) => getSaga<TrustSupplier[]>(p)),
  takeLatest<any>(getFraudFlags.toString(), (p: SagaGenericParams<FraudFlag[]>) => getSaga<FraudFlag[]>(p)),
  takeLatest<any>(getDisputes.toString(), (p: SagaGenericParams<Dispute[]>) => getSaga<Dispute[]>(p)),
  takeLatest<any>(getVerifications.toString(), (p: SagaGenericParams<ListingVerification[]>) =>
    getSaga<ListingVerification[]>(p)
  ),
  takeLatest<any>(setTrustTier.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(setQualityFloor.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(resolveFraudFlag.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(setDisputeStatus.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(decideVerification.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
];

export default trustSaga;
